/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainEntitiesDocumentsContentType, FxIdDomainEntitiesDocumentsContentTypeFromJSONTyped, FxIdDomainEntitiesDocumentsContentTypeToJSON, } from './FxIdDomainEntitiesDocumentsContentType';
export function FxIdDomainEntitiesDocumentsDocumentContentContentTypeFromJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentContentContentTypeFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentContentContentTypeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesDocumentsContentType(json)) {
        return FxIdDomainEntitiesDocumentsContentTypeFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainEntitiesDocumentsDocumentContentContentTypeToJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentContentContentTypeToJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentContentContentTypeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainEntitiesDocumentsContentType(value)) {
        return FxIdDomainEntitiesDocumentsContentTypeToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainEntitiesDocumentsDocumentContentContentType.js.map